<!-- Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved. -->

<div class="main-content" appLifecycleTracker trackerName="profile-contact-info" *ngIf="user$ | async as user">
  <div *ngIf="profileDataHasLoaded">
          <span class="profile-data-loaded"></span>
  </div>
  <div style="display: flex; justify-content: center;">
    <mat-tab-group *ngIf="profileDataHasLoaded" [(selectedIndex)]="selectedTab"
                   style="margin-top: -10px" animationDuration="0ms">
      <mat-tab *ngIf="!forcePassword && !forceTwoFactor" label="{{profileTab}}" id="profile-profile-tab">
        <div id="profileCard" [ngClass]="{ 'show': showProfileCard, 'hide': !showProfileCard }">

        <mat-card appearance="raised" class="contact-card">
          <button mat-raised-button color="primary" *ngIf="user.delete_keys_button === 1" (click)="deleteAllKeys()" style="float: right">
            {{pDeleteKeysButton}}</button>
          <h2>{{pTitleText}}</h2>
          <p>{{pTitleDesc}}</p>
          <hr />
          <div *ngIf="user">
            <form [formGroup]="registerForm">
              <div>
                <mat-form-field appearance="outline">
                  <mat-label>{{fFirstName}}</mat-label>
                  <input matInput type="text" formControlName="fname" maxlength="255"/>
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>{{fLastName}}</mat-label>
                  <input matInput type="text" formControlName="lname" maxlength="255"/>
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>{{fEmail}}</mat-label>
                  <input matInput appDebounceInput debounceTime="250" (debounceInput)="onEmailBlur($event, user)"
                         type="text" formControlName="email" (blur)="onEmailBlur($event, user)"
                         [ngClass]="{ 'is-invalid': f.email.errors }" required/>
                  <mat-error *ngIf="f.email.errors?.required">{{fEmailReq}}</mat-error>
                  <mat-error *ngIf="f.email.errors?.emailExists">{{fEmailExists}}</mat-error>
                  <mat-error *ngIf="f.email.errors?.email">{{fEmailValid}}</mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>{{fZip}}</mat-label>
                  <input matInput type="text" formControlName="zip" />
                    <mat-error *ngIf="f.zip.errors?.pattern">
                      {{ 'ZIP_INVALID_FORMAT' | translate }}
                    </mat-error>
                </mat-form-field>

                <app-country-code-form-field
                    [styles]="countryCodeStyles"
                    [formGroup]="registerForm"
                    [zipCodeControl]="registerForm.controls.zip"
                    [required]="false">
                </app-country-code-form-field>

              </div>
              <div class="button-wrapper">
                <button mat-raised-button
                        appThrottleClick throttleTime="5000" (throttleClick)="onSubmit(user)" color="primary">
                  {{pSubmitButton}}
                </button>
              </div>
            </form>
          </div>
        </mat-card>
      </div>

      <!---------- VERIFY EMAIL FORM ------------>
         <div id="verifyCard" [ngClass]="{ 'show': !showProfileCard, 'hide': showProfileCard }">
          <mat-card appearance="raised" class="contact-card">
             <form [formGroup]="verifyCodeFormGroup" (ngSubmit)="onVerify(user)">
              <div class="form-row verify-outcome">
                <div class="verify-email-header">{{evTitleText}}</div>
                <div class="verify-email-header-sub">{{evTitleDesc}}</div>
                <div class="code-emailed-to">{{evSentText}} <strong>{{ this.registerForm.value.email }}</strong></div>
                  <div class="center">
                      <button mat-stroked-button type="button" [disabled]="!canEmailUser"
                              appThrottleClick throttleTime="5000" (throttleClick)="onResendClick()">
                          {{evResendText}}
                      </button>
                  </div>

                  <div class="validation-form-field-wrapper">
                    <div>
                        <mat-form-field appearance="outline" class="free-trial-input">
                            <mat-label>{{evCodeText}}</mat-label>
                            <input matInput name="hiddenFieldToStopBrowserAutofillVerify" placeholder="{{evCodePlaceholder}}" formControlName="verifyCode" required />
                            <mat-error *ngIf="e.verifyCode.errors" class="invalid-feedback">
                                @if (e.verifyCode.errors.required) {
                                    {{evErrorText}}
                                } @else {
                                    {{evInvalidText}}
                                }
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
              </div>
              <div class="verify-button-wrapper">
                <button *ngIf="!loading" mat-flat-button color="primary" type="submit">
                  {{evSubmitText}}
                </button>
                <button disabled="true" *ngIf="loading" mat-flat-button color="primary" type="button">
                  <span><span class="mdi mdi-dots-circle mdi-spin title-icon"></span></span>
                  {{evWaitText}}
                </button>
              </div>
            </form>
          </mat-card>
          </div>
        </mat-tab>

      <!---------- PASSWORD TAB ------------>

      <mat-tab *ngIf="isCigentUser && (forcePassword || !forcePassword && !forceTwoFactor)" label="{{passwordTab}}" id="profile-password-tab">
        <mat-card appearance="raised" class="password-card">
          <div *ngIf="!forcePassword">
          <h2>{{pwTitleText}}</h2>
          </div>
          <div *ngIf="forcePassword">
          <h2>{{pwTitleDescA}}</h2>
          </div>
          <p>{{pwTitleDescB}}</p>
          <hr />

          <app-password mode="UPDATE" [email]="emailFromToken"></app-password>

        </mat-card>
      </mat-tab>

      <!-------- 2FA TAB --------->

      <mat-tab *ngIf="isCigentUser && (!forcePassword && forceTwoFactor || !forcePassword && !forceTwoFactor)" label="{{twoFactorTab}}">
        <mat-card appearance="raised" class="two-fa-card">
          <h2>{{tfTitleText}}</h2>
          <p>{{tfDescText}}</p>
          <hr />
          <div class="authenticator-image">
            <img src="../../assets/google-authenticator.png" alt="Google Authenticator Image" />
          </div>
          <p class="two-fa-info">
            {{tfInfo}}
          </p>
          <div class="center">
            <div class="two-fa-settings">
              <h3>{{tfSettings}}</h3>
              <span>{{tfStatusText}}</span>
              <span class="two-fa-status"
                  [ngClass]="{'two-fa-status-enabled': user.second_factor_enabled === 1, 'two-fa-status-disabled': user.second_factor_enabled !== 1}">
                    {{user.second_factor_enabled === 1 ? tfEnabled : tfDisabled}}
              </span>
            </div>
            <div *ngIf="generatedNewRecoveryCode" class="new-recovery-code">
                <span class="code-text">{{newRecoveryCode}}</span>
                <button
                  class="download-button"
                  mat-flat-button
                  (click)="onDownloadNewRecoveryCodeFile()">{{tfRecoveryButton}}
                </button>
                <div>{{tfRecovery}}</div>
            </div>
            <div class="two-fa-button-wrapper">
              <button mat-raised-button color="primary" *ngIf="user.second_factor_enabled !== 1; else disable" (click)="openDialog(user)">
                {{tfActivate}}</button>
              <ng-template #disable>
                <button mat-stroked-button (click)="onNewRecoveryCode()">{{tfNewRecovery}}</button>
                <button mat-raised-button color="primary" (click)="onDisable2FA()">{{tfDeactivate}}</button>
              </ng-template>
            </div>
          </div>
        </mat-card>
      </mat-tab>

      <mat-tab *ngIf="!forcePassword && !forceTwoFactor && !isD3EFreeUser && user.role === UserRole.ADMIN && appComponent.notificationsEnabled(user)" label="{{notificationsTab}}" class="profile-tabs">
          <app-user-settings [user]="user"></app-user-settings>
      </mat-tab>

    </mat-tab-group>
  </div>
</div>

